import * as moment from 'moment';
import { CalculationSettingsModel, RNAVModel } from './configuration';
import { LatLonDMS } from './coord-dms';
import { CurvePointDTO } from './curvePointDTO';
import { ImportCSVTableFieldModel } from './ImportCSV';
import { Procedure, ProcedureModel } from './procedure';
import { ScreeningAngle } from './screening-angle';
import { Sectorization } from './sectorization';
import { pickBy } from 'lodash';
import { NavaidTypes } from './EnumTypes';
import { Distance } from '../utils/distance';
import { UtilsService } from '../services/utils.service';
import { AnyMxRecord } from 'dns';
import { AirSpaceBoundaryModel } from './air-space-boundary';
import { VicentyToolControlService } from '../services/vicenty-tool-control.service';
import { ChannelFreqObject } from './ChannelFreqObject';
import { FreqConversionUtil } from './FreqConversionUtil';
import { AntennaModel } from './antennaModel';

export class PerformanceReportNavaidModel{
  navaidId: string;
  name:string;
  navaidType:string;

  latitude:string;
  longitude:string;
  altitude: number;

  doc: number

  sectorized: string;
  channel: string
  notes: string;
  vhfTunFreqInput: string


  defineFrequenciesFromChannel() : void {
    let channelFreqObject : ChannelFreqObject = null;
    channelFreqObject = FreqConversionUtil.findByChannel(this.channel);

    if(channelFreqObject != null){
      if(channelFreqObject.vorFreq != null){
        this.vhfTunFreqInput = channelFreqObject.vorFreq.toString();
      }
      else{
        this.vhfTunFreqInput = null;
      }
    }
  }


}



export class NavaidModel{

  antennaModelName: string = null;

  static duplicateDistance:number = 1000;
  static desktopduplicationDistance = 1000;
  static isRNAV(navaidtype:string){
    return navaidtype == NavaidTypes.DME||
          navaidtype == NavaidTypes.VOR_DME ||
          navaidtype == NavaidTypes.TACAN   ||
          navaidtype == NavaidTypes.VORTAC;

  }

  static objectFieldIsArray(field:string){
    return  field == "sectorizations" ||
            field == "associatedProcedures" ||
            field == "associatedAirspaceBoundaries" ||
            field == "associatedProceduresCritical" ||
            field == "actualScreeningAngle";
  }
  static navaidsAreDuplicates(navaid1:NavaidModel,navaid2:NavaidModel,useOnlyCriteria2?:boolean){
    if(navaid1.navaidtype == "NDB" || navaid2.navaidtype == "NDB"  || navaid1.projectId != navaid2.projectId){ //NDB exception
      return false;
    }
    let duplicateCriteria1 = navaid1.navaidid == navaid2.navaidid &&
    navaid1.icaocc == navaid2.icaocc &&
    navaid1.navaidtype == navaid2.navaidtype;

    let duplicateCriteria2 = navaid1.navaidid == navaid2.navaidid &&
    navaid1.icaocc == navaid2.icaocc && navaid1.navaidtype != navaid2.navaidtype
    VicentyToolControlService.calculateDistance(navaid1.latitude,navaid1.longitude,navaid2.latitude,navaid2.longitude) < NavaidModel.duplicateDistance;

    return useOnlyCriteria2? duplicateCriteria2: (duplicateCriteria1 || duplicateCriteria2);

  }
  static duplicationCheckDesktopCondition(navaid1:NavaidModel,navaid2: NavaidModel){
    return Distance.distanceBetweenPoints(navaid1.latitude,navaid1.longitude,navaid2.latitude,navaid2.longitude) <= NavaidModel.desktopduplicationDistance
      && navaid1.id != navaid2.id && navaid1.projectId == navaid2.projectId;
  }

  addSectorization(sect: Sectorization) {
    this.sectorizations.push(sect);
  }

  addMinimumScreeningAngle(angle: ScreeningAngle) {
    this.actualScreeningAngle.push(angle);
  }

  removeSectorization(sect: Sectorization) {
    const index = this.sectorizations.indexOf(sect, 0);
    if (index > -1) {
      this.sectorizations.splice(index, 1);
   }
  }

  removeAngle(angle: ScreeningAngle) {
    const index = this.actualScreeningAngle.indexOf(angle, 0);
    if (index > -1) {
      this.actualScreeningAngle.splice(index, 1);
   }
  }
  navaidFiles: NavaidFile[] = [];
  dataType: number;
  antennatype: string;
  private _antheight: number;
  get antheight() : number{
    return Math.round(this._antheight * 100) / 100;
  }
  set antheight(value : number){
    this._antheight = Math.round(value * 100) / 100;
  }
  effectiveHeight: number;
  private _antheightMeters: number;
  get antheightMeters() : number{
    return Math.round(this._antheightMeters * 100) / 100;
  }
  set antheightMeters(value : number){
    this._antheightMeters = Math.round(value * 100) / 100;
  }
  arinc424fom: string;
  bias: number;
  cableloss: number;
  channel: string;
  vhfTunFreqInput : string;
  uhfUplinkFreqInput : number;
  uhfDownlinkFreqInput : number;
  cone: number;
  configId: number;
  declaredeirp: number;
  dmetacanclass: string;
  doc: string;

  isSectOrScreeningOrFileLine?: boolean// csv import error feedback helper

  private _dueforreplacement: string = null;
  get dueforreplacement() : string{
    return moment(this._dueforreplacement).isValid() ? moment(this._dueforreplacement).format('yyyy-MM-DD') : null;
  }
  set dueforreplacement(value : string){
    this._dueforreplacement = this.checkDateValid(value) ? this.getFormatedDate(value) : null;
  }
  private _elevation: string = "0"; // TODO: hardcoded, we need to get this information from configuration when implemented
  get elevation() : string{
    return this._elevation == null? null : (Math.round(Number.parseFloat(this._elevation) * 100) / 100).toString();
  }
  set elevation(value : string){
    this._elevation = value == null? null : (Math.round(Number.parseFloat(value) * 100) / 100).toString();
  }
  private _elevationMeters: string = "0"; // TODO: hardcoded, we need to get this information from configuration when implemented
  get elevationMeters() : string{
    return (Math.round(Number.parseFloat(this._elevationMeters) * 100) / 100).toString();
  }
  set elevationMeters(value : string){
    this._elevationMeters = (Math.round(Number.parseFloat(value) * 100) / 100).toString();
  }
  private _elevationTerrainFeet: number;
  get elevationTerrainFeet() : number{
    return Math.round(this._elevationTerrainFeet * 100) / 100;
  }
  set elevationTerrainFeet(value : number){
    this._elevationTerrainFeet = Math.round(value * 100) / 100;
  }
  private _elevationTerrainMeters: number;
  get elevationTerrainMeters() : number{
    return Math.round(this._elevationTerrainMeters * 100) / 100;
  }
  set elevationTerrainMeters(value : number){
    this._elevationTerrainMeters = Math.round(value * 100) / 100;
  }
  private _elevationRelativeTerrainFeet: number;
  get elevationRelativeTerrainFeet() : number{
    return Math.round(this._elevationRelativeTerrainFeet * 100) / 100;
  }
  set elevationRelativeTerrainFeet(value : number){
    this._elevationRelativeTerrainFeet = Math.round(value * 100) / 100;
  }
  private _elevationRelativeTerrainMeters: number;
  get elevationRelativeTerrainMeters() : number{
    return Math.round(this._elevationRelativeTerrainMeters * 100) / 100;
  }
  set elevationRelativeTerrainMeters(value : number){
    this._elevationRelativeTerrainMeters = Math.round(value * 100) / 100;
  }
  equipmenttype: string;
  fligthinspectioninterval: number;
  icaocc: string;
  id: string;
  infosrce: string;
  private _infoupdate: string = null;
  get infoupdate() : string{
    return moment(this._infoupdate).isValid() ? moment(this._infoupdate).format('yyyy-MM-DD') : null;
  }
  set infoupdate(value : string){
    this._infoupdate = this.checkDateValid(value) ? this.getFormatedDate(value) : null;
  }
  private _lastinspection: string = null;
  get lastinspection() : string{
    return moment(this._lastinspection).isValid() ? moment(this._lastinspection).format('yyyy-MM-DD') : null;
  }
  set lastinspection(value : string){
    this._lastinspection = this.checkDateValid(value) ? this.getFormatedDate(value) : null;
  }
  private _latitude: number = 0;
  get latitude() : number{
    return Math.round(this._latitude * 100000) / 100000;
  }
  set latitude(value : number){
    this._latitude = Math.round(value * 100000) / 100000;
  }
  private _longitude: number = 0;
  get longitude() : number{
    return Math.round(this._longitude * 100000) / 100000;
  }
  set longitude(value : number){
    this._longitude = Math.round(value * 100000) / 100000;
  }
  latLonDms:LatLonDMS = new LatLonDMS();
  vorLatLonDms:LatLonDMS = new LatLonDMS();
  losthreshold: string;
  manufacturer: string;
  maxaltitude: number;
  maxaltitudeMeters: number;
  maxload: number;
  meetingpost1989sarps: string;
  sectorizations: Sectorization[] = [];
  associatedProcedures: ProcedureModel[] = [];
  associatedProceduresCritical: ProcedureModel[] = [];
  associatedAirspaceBoundaries: AirSpaceBoundaryModel[] = [];
  actualScreeningAngle: ScreeningAngle[] = [];
  model: string;
  mtbo: number;
  name: string;
  navaidid: string;
  navaidtype: string;
  ndbfrequency: string;
  notes: string;
  notupdate: string;
  offsetdist: number;
  private _operationalsince: string = null;

  get operationalsince() : string{
    return moment(this._operationalsince).isValid() ? moment(this._operationalsince).format('yyyy-MM-DD') : null;
  }
  set operationalsince(value : string){
    this._operationalsince = this.checkDateValid(value) ? this.getFormatedDate(value) : null;
  }

  operationalstatus: string;
  operator: string;
  _plannedinspection: string = null;
  get plannedinspection() : string{
    return moment(this._plannedinspection).isValid() ? moment(this._plannedinspection).format('yyyy-MM-DD') : null;
  }
  set plannedinspection(value : string){
    this._plannedinspection = this.checkDateValid(value) ? this.getFormatedDate(value) : null;
  }
  private _plannedremoval: string = null;
  get plannedremoval() : string{
    return moment(this._plannedremoval).isValid() ? moment(this._plannedremoval).format('yyyy-MM-DD') : null;
  }
  set plannedremoval(value : string){
    this._plannedremoval = this.checkDateValid(value) ? this.getFormatedDate(value) : null;
  }
  projectId: number;
  quiescentsquitterrate: number;
  sectorizationtext: string;
  transmoutpower: number;
  updated: string;
  userdefined: boolean = false;
  usesectorization: string;
  vordocmaxrange: number;
  private _vordueforreplace: string = null;
  get vordueforreplace() : string{
    return moment(this._vordueforreplace).isValid() ? moment(this._vordueforreplace).format('yyyy-MM-DD') : null;
  }
  set vordueforreplace(value : string){
    this._vordueforreplace = this.checkDateValid(value) ? this.getFormatedDate(value) : null;
  }
  vorinpectioninterval: Number;
  _vorlastinsp: string = null;
  get vorlastinsp() : string{
    return moment(this._vorlastinsp).isValid() ? moment(this._vorlastinsp).format('yyyy-MM-DD') : null;
  }
  set vorlastinsp(value : string){
    this._vorlastinsp = this.checkDateValid(value) ? this.getFormatedDate(value) : null;
  }

  private _vorlatitude: number = 0;
  get vorlatitude() : number{
    return Math.round(this._vorlatitude * 100000) / 100000;
  }
  set vorlatitude(value : number){
    this._vorlatitude = Math.round(value * 100000) / 100000;
  }

  private _vorlongitude: number = 0;
  get vorlongitude() : number{
    return Math.round(this._vorlongitude * 100000) / 100000;
  }
  set vorlongitude(value : number){
    this._vorlongitude = Math.round(value * 100000) / 100000;
  }

  vormanufacturer: string;
  vormodel: string;
  private _voroperationalsince: string = null;
  get voroperationalsince() : string{
    return moment(this._voroperationalsince).isValid() ? moment(this._voroperationalsince).format('yyyy-MM-DD') : null;
  }
  set voroperationalsince(value : string){
    this._voroperationalsince = this.checkDateValid(value) ? this.getFormatedDate(value) : null;
  }
  voroperstatus: string;
  private _vorplannedinspection: string = null;
  get vorplannedinspection() : string{
    return moment(this._vorplannedinspection).isValid() ? moment(this._vorplannedinspection).format('yyyy-MM-DD') : null;
  }
  set vorplannedinspection(value : string){
    this._vorplannedinspection = this.checkDateValid(value) ? this.getFormatedDate(value) : null;
  }
  private _vorplannedremoval: string = null;
  get vorplannedremoval() : string{
    return moment(this._vorplannedremoval).isValid() ? moment(this._vorplannedremoval).format('yyyy-MM-DD') : null;
  }
  set vorplannedremoval(value : string){
    this._vorplannedremoval = this.checkDateValid(value) ? this.getFormatedDate(value) : null;
  }
  vortype: string;
  critical : boolean;
  isselected:boolean = false;
  isItu: boolean = false;

  public removeXMLDateFormat(){
    this.infoupdate = this.getFormatedDate(this.infoupdate);
    this.dueforreplacement = this.getFormatedDate(this.dueforreplacement);
  }
  checkDateValid(value) {
    if(value != null && value.includes('T')){
      value = value.substring(0, value.indexOf('T'));
    }

    let testDateFormatDesktop = moment( value, 'DD-MM-YYYY', true).isValid() ;
    let testDateFormatWeb = moment( value, 'YYYY-MM-DD', true).isValid()  ;

    return testDateFormatDesktop || testDateFormatWeb;
  }

  getFormatedDate(value){
    if(value != null && value.includes('T')){
      value = value.substring(0, value.indexOf('T'));
    }
    let testDateFormatDesktop = moment( value, 'DD-MM-YYYY', true).isValid();

    if (testDateFormatDesktop){
      return moment( value, 'DD-MM-YYYY', true).format("yyyy-MM-DD");
    } else {
      return moment( value, 'YYYY-MM-DD', true).format("yyyy-MM-DD");
    }
  }

  eadFrequencyCorrected: boolean = false;

  getInformation(){
    let information = "";

    information += '<h4 style="font-weight:bold">Navaid</h4>';
    information += "<p>ID: " + this.navaidid + "</p>";
    information += "<p>Name: " + this.name + "</p>";
    information += "<p>Type: " + this.navaidtype + "</p>";
    information += "<p>ICAO Code: " + this.icaocc + "</p>";
    information += "<p>Elevation: " + this.elevation + "</p>";
    information += "<p>Latitude: " + this.latitude + "</p>";
    information += "<p>Longitude: " + this.longitude + "</p>";
    information += "<p>User Defined: " + this.userdefined + "</p>";
    information += "<p>Sectorized: " + this.usesectorization + "</p>";
    information += "<p>DOC: " + this.doc + "</p>";
    information += "<p>Max Altitude: " + this.maxaltitude + "</p>";
    information += "<p>Frequency: " + this.vhfTunFreqInput + "</p>";
    information += "<p>Updated: " + this.updated + "</p>";

    return information;
  }

  /*
	 * DME -> 0
	 * VOR/DME -> 1
	 * TACAN -> 2
	 * VORTAC -> 3
	 * DME(ILS) -> 4
	 * VOR -> 5
	 * NDB->6
	 */
	public static getTypeFromNumber(type: number): string {
		switch (type) {
		case 0:
			return NavaidTypes.DME;
		case 1:
			return NavaidTypes.VOR_DME;
		case 2:
			return NavaidTypes.TACAN;
		case 3:
			return NavaidTypes.VORTAC;
		case 4:
			return NavaidTypes.DME_ILS;
		case 5:
			return NavaidTypes.VOR;
		case 6:
			return NavaidTypes.NDB;
		default:
			return null;
		}
	}


}
export class NavaidFile{
  id: number;
  fileData: any ;
  fileType: string;
  navaidId: number;
  projectId: number;
  fileName: string;
}
export class NavaidDTOCalculation {
  uniqueId: string;
  id: string;
  type:string;
  latitude: number;
  longitude: number;
  elevation: number;
  elevationMeters: number;
  maxaltitude: number;
  maxaltitudeMeters: number;
  effectiveHeight: number;
  doc: number;
  coneOfSilenceAngle: number;
  maxOperationalFL: number;
  vorFrequency: number;
  usesKeyHoling: boolean;
  mtbo: number;
  forceCalculation: boolean;
  LOSMarginAngle: number;
  screeningAngRestrictionsCount: number;
  vorDmeDocConstrain: number;
  transmutPower: number;
  screeningAngRestrictions: ScreeningAngRestrictions[];
  sortedSectors: SortedSectors[];
  sectorizations: Sectorization[];
  icaocc: string;
  name:string;
  declaredEIRP: number;
  channel: string;
  antennaModelName: string = null;
  dataBaseId?: string;
  private _antheightMeters: number;
  get antheightMeters(): number {
    return Math.round(this._antheightMeters * 100) / 100;
  }
  set antheightMeters(value: number) {
    this._antheightMeters = Math.round(value * 100) / 100;
  }
  static transformNavaidModelInNavaidDTOCalculation(navaid : NavaidModel) : NavaidDTOCalculation{
    let dto : NavaidDTOCalculation = new NavaidDTOCalculation;
    dto.uniqueId = navaid.navaidid + '_' +navaid.icaocc + '_' + navaid.navaidtype;
    dto.id = navaid.navaidid;
    dto.type = navaid.navaidtype;
    dto.latitude = navaid.latitude;
    dto.longitude = navaid.longitude;
    dto.elevation = Number.parseFloat(navaid.elevation);
    dto.elevationMeters = Number.parseFloat(navaid.elevationMeters);
    dto.maxaltitude = navaid.maxaltitude;
    dto.maxaltitudeMeters = navaid.maxaltitudeMeters;
    dto.effectiveHeight = navaid.effectiveHeight;
    dto.doc = Number.parseInt(navaid.doc);
    dto.coneOfSilenceAngle = navaid.cone;
    dto.maxOperationalFL = navaid.maxaltitude / 100;
    dto.vorFrequency = navaid.uhfUplinkFreqInput;
    dto.usesKeyHoling = navaid.usesectorization == "True" ? true : false;
    dto.mtbo = navaid.mtbo;
    dto.forceCalculation = false;
    dto.LOSMarginAngle = 0;
    dto.screeningAngRestrictionsCount = 0;
    dto.screeningAngRestrictions = new Array<ScreeningAngRestrictions>();
    dto.vorDmeDocConstrain = navaid.vordocmaxrange;
    dto.transmutPower = navaid.transmoutpower;
    dto.sortedSectors = new Array<SortedSectors>();
    dto.sectorizations = navaid.sectorizations;
    dto.icaocc = navaid.icaocc;
    dto.declaredEIRP = navaid.declaredeirp;
    return dto;
  }
}

export class ScreeningAngRestrictions {
  startHorizontalAngle: number;
  endHorizontalAngle: number;
  minScreeningAngle: number;
}

export class SortedSectors {
  minHeight: number;
  maxHeight: number;
  minAngle: number;
  maxAngle: number;
  doc: number;
}

export class NavaidSitingToolModel {
  name: string = "";
  sitingResults: string = "Full";
  visibilityAnalysis: boolean = false;
  flightLevel: number;
  flightLevelMeters: number;
  sectorCellHeight: string ="Minimum";
  doc: number = 160;
  minSubtendedAngle: number = 30;
  maxSubtendedAngle: number = 180 - this.minSubtendedAngle;
  coordinates: CurvePointDTO[] = [];
  type: string;
  navaids: NavaidDTOCalculation[] = [];
  calculationSettings: CalculationSettingsModel;
  rnav: RNAVModel;
  projectId: number;
}

export class NavAidsCsvModel {
  table : ImportCSVTableFieldModel[] = [];
  dataStartingLine : number = 2;
  fieldSeparator : string = ";";
  decimalSeparator : string = ",";
  countryCoteType: string = "ICAO";
  fileDataSource: string = "Published";
  file : File;
  fileContent : NavaidModel[] = [];
  tableLocalStorageKey = 'importNavAidTableConfig';

  saveTableConfig(){
    localStorage.setItem(this.tableLocalStorageKey, JSON.stringify(this.table));
  }

  loadTableConfigFromLocalStore() : ImportCSVTableFieldModel[]{
    const tableConfig = JSON.parse(localStorage.getItem(this.tableLocalStorageKey));

    return tableConfig;
  }

  fillTable() : void {
    const tableFromLocalConfig = this.loadTableConfigFromLocalStore();

    if (tableFromLocalConfig && tableFromLocalConfig.length > 0 && false)
      this.table.push(... tableFromLocalConfig);
    else {
      this.table.push(new ImportCSVTableFieldModel("Navaid ID","B", true));
      this.table.push(new ImportCSVTableFieldModel("Navaid Name","D"));
      this.table.push(new ImportCSVTableFieldModel("Navaid Type","E", true));
      this.table.push(new ImportCSVTableFieldModel("Latitude","F", true));
      this.table.push(new ImportCSVTableFieldModel("Longitude","G", true));
      this.table.push(new ImportCSVTableFieldModel("Country Code","P", true));
      this.table.push(new ImportCSVTableFieldModel("Elevation","H"));
      this.table.push(new ImportCSVTableFieldModel("Antena Height","I"));
      this.table.push(new ImportCSVTableFieldModel("DOC","J"));
      this.table.push(new ImportCSVTableFieldModel("Maximum Altitude","K"));
      this.table.push(new ImportCSVTableFieldModel("Data Type","C"));
      this.table.push(new ImportCSVTableFieldModel("Sectorization Text","L"));
      this.table.push(new ImportCSVTableFieldModel("LOS Threshold","M"));
      this.table.push(new ImportCSVTableFieldModel("User Defined","N"));
      this.table.push(new ImportCSVTableFieldModel("Not update","O"));
      this.table.push(new ImportCSVTableFieldModel("Use Sectorization","Q"));
      this.table.push(new ImportCSVTableFieldModel("Cone of Silence","R"));
      this.table.push(new ImportCSVTableFieldModel("Info Source","S"));
      this.table.push(new ImportCSVTableFieldModel("Info Update","T"));
      this.table.push(new ImportCSVTableFieldModel("Channel","U"));
      this.table.push(new ImportCSVTableFieldModel("Meeting Post 1989","V"));
      this.table.push(new ImportCSVTableFieldModel("Manufacturer","W"));
      this.table.push(new ImportCSVTableFieldModel("Model","X"));
      this.table.push(new ImportCSVTableFieldModel("Equipment Type","Y"));
      this.table.push(new ImportCSVTableFieldModel("Antenna Type","Z"));
      this.table.push(new ImportCSVTableFieldModel("Operator","AA"));
      this.table.push(new ImportCSVTableFieldModel("Transmute Out Power","AB"));
      this.table.push(new ImportCSVTableFieldModel("Cable Loss","AC"));
      this.table.push(new ImportCSVTableFieldModel("Declared EIRP","AD"));
      this.table.push(new ImportCSVTableFieldModel("BIAS","AE"));
      this.table.push(new ImportCSVTableFieldModel("Maximum Load","AF"));
      this.table.push(new ImportCSVTableFieldModel("Quiescent SquitterRate","AG"));
      this.table.push(new ImportCSVTableFieldModel("MTBO","AH"));
      this.table.push(new ImportCSVTableFieldModel("Operation Since","AI"));
      this.table.push(new ImportCSVTableFieldModel("Operation Status","AJ"));
      this.table.push(new ImportCSVTableFieldModel("DME TACAN Class","AK"));
      this.table.push(new ImportCSVTableFieldModel("Due for Replacement","AL"));
      this.table.push(new ImportCSVTableFieldModel("Planned Removal","AM"));
      this.table.push(new ImportCSVTableFieldModel("Last Inspection","AN"));
      this.table.push(new ImportCSVTableFieldModel("PLanned Inspection","AO"));
      this.table.push(new ImportCSVTableFieldModel("Flight Inspection Interval","AP"));
      this.table.push(new ImportCSVTableFieldModel("Org Mid","AQ"));
      this.table.push(new ImportCSVTableFieldModel("VOR Mid","AR"));
      this.table.push(new ImportCSVTableFieldModel("Used in DME","AS"));
      this.table.push(new ImportCSVTableFieldModel("AHP Mid","AT"));
      this.table.push(new ImportCSVTableFieldModel("VOR Type","AU"));
      this.table.push(new ImportCSVTableFieldModel("VOR Latitude","AV"));
      this.table.push(new ImportCSVTableFieldModel("VOR Longitude","AW"));
      this.table.push(new ImportCSVTableFieldModel("VOR DOC Maximum Range","AX"));
      this.table.push(new ImportCSVTableFieldModel("VOR Manufacturer","AY"));
      this.table.push(new ImportCSVTableFieldModel("VOR Model","AZ"));
      this.table.push(new ImportCSVTableFieldModel("VOR Operation Status","BA"));
      this.table.push(new ImportCSVTableFieldModel("VOR Operational Since","BB"));
      this.table.push(new ImportCSVTableFieldModel("VOR Due for Replacement","BC"));
      this.table.push(new ImportCSVTableFieldModel("VOR Planned Removal","BD"));
      this.table.push(new ImportCSVTableFieldModel("VOR Last Inspection","AN"));
      this.table.push(new ImportCSVTableFieldModel("VOR Inspection Interval","BF"));
      this.table.push(new ImportCSVTableFieldModel("VOR Planned Inspection","BG"));
      this.table.push(new ImportCSVTableFieldModel("NDB Frequency","BH"));
      this.table.push(new ImportCSVTableFieldModel("Offset Distance","BI"));
      this.table.push(new ImportCSVTableFieldModel("ARINC424FOM","BJ"));
      this.table.push(new ImportCSVTableFieldModel("Updated","BK"));
      this.table.push(new ImportCSVTableFieldModel("Notes","BL"));
      this.table.push(new ImportCSVTableFieldModel("Sectorization ID", "BM"));
      this.table.push(new ImportCSVTableFieldModel("Sectorization DOC", "BN"));
      this.table.push(new ImportCSVTableFieldModel("Sectorization Minimum Angle", "BO"));
      this.table.push(new ImportCSVTableFieldModel("Sectorization Maximum Angle", "BP"));
      this.table.push(new ImportCSVTableFieldModel("Sectorization Minimum Altitude", "BQ"));
      this.table.push(new ImportCSVTableFieldModel("Sectorization Maximum Altitude", "BR"));
      this.table.push(new ImportCSVTableFieldModel("Normal Sectorization", "BS"));
      this.table.push(new ImportCSVTableFieldModel("Actual Screening Angle ID", "BT"));
      this.table.push(new ImportCSVTableFieldModel("Actual Screening Angle", "BU"));
      this.table.push(new ImportCSVTableFieldModel("Maximum Screening Angle", "BV"));
      this.table.push(new ImportCSVTableFieldModel("Vertical Screening Angle", "BW"));
      this.table.push(new ImportCSVTableFieldModel("Inspection Rep Path ID", "BX"));
      this.table.push(new ImportCSVTableFieldModel("Inspection Rep Path", "BY"));
      this.table.push(new ImportCSVTableFieldModel("Antena Rep Path ID", "BZ"));
      this.table.push(new ImportCSVTableFieldModel("Antena Rep Path", "CA"));
      this.table.push(new ImportCSVTableFieldModel("VOR Inspect Path ID", "CB"));
      this.table.push(new ImportCSVTableFieldModel("VOR Inspect Path", "CC"));
      this.table.push(new ImportCSVTableFieldModel("Antenna Model Name", "CD", false, false));
      this.table.push(new ImportCSVTableFieldModel("Navaid File Data", "CE"));
      this.table.push(new ImportCSVTableFieldModel("Navaid File Type", "CF"));
      this.table.push(new ImportCSVTableFieldModel("Navaid File ID", "CG"));
      this.table.push(new ImportCSVTableFieldModel("Navaid File NavaidId", "CH"));
      this.table.push(new ImportCSVTableFieldModel("Navaid File ProjectID", "CI"));
      this.table.push(new ImportCSVTableFieldModel("Navaid File Name", "CJ"));
    }
  }

  saveData(): NavAidsCsvModel{
    let newModel : NavAidsCsvModel = new NavAidsCsvModel();
    newModel.dataStartingLine = this.dataStartingLine;
    newModel.fieldSeparator = this.fieldSeparator;
    newModel.decimalSeparator = this.decimalSeparator;
    return newModel;
  }
}

export class NavAidsCSVContent{

  public static readonly ERROR_PARSING_NUMBER = -20000;

  static parseNumber(value): number{
    if (value == undefined){
      undefined;
    } else {
      if (isNaN(value)){
        return NavAidsCSVContent.ERROR_PARSING_NUMBER;
      }
      return Number(value);
    }
  }

  static parseDmeTacanClass(value: string){
    if(value == null ||  value == 'null'){
      return null;
    }
    return value.replace('&','_')
  }
  static  ToUpperCase(value:string){
    if(value == null ||  value == 'null'){
      return null;
    }
    return value.toUpperCase();
  }
  static removeNulls(csvLine: any){
    for(let i in csvLine){
      if(csvLine[i] == 'null' || csvLine[i] == ''){
        csvLine[i]  = undefined;
      }
    }
  }
  static map(csvLine: any, table: ImportCSVTableFieldModel[],utilsService: UtilsService): NavaidModel {
    var line : NavaidModel = new NavaidModel();

    const registryType : number = Number(csvLine[ImportCSVTableFieldModel.convertLetterToNumber(ImportCSVTableFieldModel.getLetterFromTable("Data Type", table))]);
    line.dataType = registryType;
    NavAidsCSVContent.removeNulls(csvLine);
    line.id = "0";
    line.navaidid = this.getFieldColumnNumber("Navaid ID", table) != null ? csvLine[this.getFieldColumnNumber("Navaid ID", table)] : null;
    line.name = (csvLine[this.getFieldColumnNumber("Navaid Name", table)]);
    line.navaidtype = this.transformNavaidType(csvLine[this.getFieldColumnNumber("Navaid Type", table)]);
    line.latitude = this.parseNumber(csvLine[this.getFieldColumnNumber("Latitude", table)]);
    line.longitude = this.parseNumber(csvLine[this.getFieldColumnNumber("Longitude", table)]);
    line.icaocc = csvLine[this.getFieldColumnNumber("Country Code", table)];
    line.elevation = csvLine[this.getFieldColumnNumber("Elevation", table)] == null? null : csvLine[this.getFieldColumnNumber("Elevation", table)];
    line.antheight = this.parseNumber(csvLine[this.getFieldColumnNumber("Antena Height", table)]);
    line.doc = csvLine[this.getFieldColumnNumber("DOC", table)];
    line.maxaltitude = this.getFieldColumnNumber("Maximum Altitude", table) != null? this.parseNumber(csvLine[this.getFieldColumnNumber("Maximum Altitude", table)]) : null;
    line.sectorizationtext = csvLine[this.getFieldColumnNumber("Sectorization Text", table)];
    line.losthreshold = csvLine[this.getFieldColumnNumber("LOS Threshold", table)];
    line.userdefined = csvLine[this.getFieldColumnNumber("User Defined", table)];
    line.notupdate = csvLine[this.getFieldColumnNumber("Not update", table)];
    line.usesectorization = csvLine[this.getFieldColumnNumber("Use Sectorization", table)];
    line.cone = this.parseNumber(csvLine[this.getFieldColumnNumber("Cone of Silence", table)]);
    line.infosrce = csvLine[this.getFieldColumnNumber("Info Source", table)];
    line.infoupdate = csvLine[this.getFieldColumnNumber("Info Update", table)];
    line.channel = csvLine[this.getFieldColumnNumber("Channel", table)];
    line.meetingpost1989sarps = csvLine[this.getFieldColumnNumber("Meeting Post 1989", table)];
    line.manufacturer = csvLine[this.getFieldColumnNumber("Manufacturer", table)];
    line.model = csvLine[this.getFieldColumnNumber("Model", table)];
    line.equipmenttype = csvLine[this.getFieldColumnNumber("Equipment Type", table)];
    line.antennatype = csvLine[this.getFieldColumnNumber("Antenna Type", table)];
    line.operator = csvLine[this.getFieldColumnNumber("Operator", table)];
    line.transmoutpower = this.parseNumber(csvLine[this.getFieldColumnNumber("Transmute Out Power", table)]);
    line.cableloss = this.parseNumber(csvLine[this.getFieldColumnNumber("Cable Loss", table)]);
    line.declaredeirp = this.parseNumber(csvLine[this.getFieldColumnNumber("Declared EIRP", table)]);
    line.bias = this.parseNumber(csvLine[this.getFieldColumnNumber("BIAS", table)]);
    line.maxload = this.parseNumber(csvLine[this.getFieldColumnNumber("Maximum Load", table)]);
    line.quiescentsquitterrate = this.parseNumber(csvLine[this.getFieldColumnNumber("Quiescent SquitterRate", table)]);
    line.mtbo = this.parseNumber(csvLine[this.getFieldColumnNumber("MTBO", table)]);
    line.operationalsince = csvLine[this.getFieldColumnNumber("Operation Since", table)];
    line.operationalstatus =  NavAidsCSVContent.ToUpperCase(csvLine[this.getFieldColumnNumber("Operation Status", table)]);
    line.dmetacanclass = NavAidsCSVContent.parseDmeTacanClass(csvLine[this.getFieldColumnNumber("DME TACAN Class", table)]);
    line.dueforreplacement = csvLine[this.getFieldColumnNumber("Due for Replacement", table)];
    line.plannedremoval = csvLine[this.getFieldColumnNumber("Planned Removal", table)];
    line.lastinspection = csvLine[this.getFieldColumnNumber("Last Inspection", table)];
    line.plannedinspection = csvLine[this.getFieldColumnNumber("PLanned Inspection", table)];
    line.fligthinspectioninterval = this.parseNumber(csvLine[this.getFieldColumnNumber("Flight Inspection Interval", table)]);
    line.vortype = NavAidsCSVContent.ToUpperCase(csvLine[this.getFieldColumnNumber("VOR Type", table)]);
    line.vorlatitude =this.parseNumber(csvLine[this.getFieldColumnNumber("VOR Latitude", table)]);
    line.vorlongitude = this.parseNumber(csvLine[this.getFieldColumnNumber("VOR Longitude", table)]);
    line.vordocmaxrange = this.parseNumber(csvLine[this.getFieldColumnNumber("VOR DOC Maximum Range", table)]);
    line.vormanufacturer = csvLine[this.getFieldColumnNumber("VOR Manufacturer", table)];
    line.vormodel = csvLine[this.getFieldColumnNumber("VOR Model", table)];
    line.voroperstatus = NavAidsCSVContent.ToUpperCase(csvLine[this.getFieldColumnNumber("VOR Operation Status", table)]);
    line.voroperationalsince = csvLine[this.getFieldColumnNumber("VOR Operational Since", table)];
    line.vordueforreplace = csvLine[this.getFieldColumnNumber("VOR Due for Replacement", table)];
    line.vorplannedremoval = csvLine[this.getFieldColumnNumber("VOR Planned Removal", table)];
    line.vorlastinsp = csvLine[this.getFieldColumnNumber("VOR Last Inspection", table)];
    line.vorinpectioninterval = this.parseNumber(csvLine[this.getFieldColumnNumber("VOR Inspection Interval", table)]);
    line.vorplannedinspection = csvLine[this.getFieldColumnNumber("VOR Planned Inspection", table)];
    line.ndbfrequency = csvLine[this.getFieldColumnNumber("NDB Frequency", table)];
    line.offsetdist = this.parseNumber(csvLine[this.getFieldColumnNumber("Offset Distance", table)]);
    let arinc424fom = utilsService.getArincFomValue(csvLine[this.getFieldColumnNumber("ARINC424FOM", table)])
    line.arinc424fom = arinc424fom == '' ? null : arinc424fom;
    line.updated = csvLine[this.getFieldColumnNumber("Updated", table)];
    line.notes = csvLine[this.getFieldColumnNumber("Notes", table)];
    line.antennaModelName = csvLine[this.getFieldColumnNumber("Antenna Model Name", table)];


    const SecIdChecked = ImportCSVTableFieldModel.getCheckedFromTable("Sectorization ID", table);
    const SecIdNotNull = csvLine[this.getFieldColumnNumber("Sectorization ID", table)] != null;
    if (SecIdChecked && SecIdNotNull) {
      line.isSectOrScreeningOrFileLine = true;
      line.addSectorization({
        doc: this.parseNumber(csvLine[this.getFieldColumnNumber("Sectorization DOC", table)]),
        minangle: this.parseNumber(csvLine[this.getFieldColumnNumber("Sectorization Minimum Angle", table)]),
        maxangle: this.parseNumber(csvLine[this.getFieldColumnNumber("Sectorization Maximum Angle", table)]),
        minaltitude: this.parseNumber(csvLine[this.getFieldColumnNumber("Sectorization Minimum Altitude", table)]),
        maxaltitude: this.parseNumber(csvLine[this.getFieldColumnNumber("Sectorization Maximum Altitude", table)]),
        id: undefined,
        isselected: false,
        istodelete: false,
      });
    }

    const ScreeningIdChecked = ImportCSVTableFieldModel.getCheckedFromTable("Actual Screening Angle ID", table);
    const ScreeningIdNotNUll = csvLine[this.getFieldColumnNumber("Actual Screening Angle", table)] != null;

    if (ScreeningIdChecked && ScreeningIdNotNUll) {
      line.isSectOrScreeningOrFileLine = true;
      line.addMinimumScreeningAngle({
        minangle: csvLine[this.getFieldColumnNumber("Actual Screening Angle", table)],
        maxangle:csvLine[this.getFieldColumnNumber("Maximum Screening Angle", table)],
        verticalangle:csvLine[this.getFieldColumnNumber("Vertical Screening Angle", table)],
        id: undefined,
        isselected : false,
        istodelete : false,
      });
    }
    const navaidFileNotNull = csvLine[this.getFieldColumnNumber("Navaid File Data",table)] != null;
    if(navaidFileNotNull){
      line.isSectOrScreeningOrFileLine = true;
      let navaidFile: NavaidFile = new NavaidFile()
      navaidFile.fileData = csvLine[this.getFieldColumnNumber("Navaid File Data",table)];
      navaidFile.fileType = csvLine[this.getFieldColumnNumber("Navaid File Type",table)]
      navaidFile.fileName = csvLine[this.getFieldColumnNumber("Navaid File Name",table)]
      navaidFile.projectId = csvLine[this.getFieldColumnNumber("Navaid File ProjectID",table)]
      navaidFile.navaidId = csvLine[this.getFieldColumnNumber("Navaid File NavaidId",table)]
      line.navaidFiles = [navaidFile];
    }



    //TODO: nof found in models
        // line.orgMid = csvLine[this.getFieldColumnNumber("Org Mid", table)];
    // line.vorMid = csvLine[this.getFieldColumnNumber("VOR Mid", table)];
    // line.usedInDme = csvLine[this.getFieldColumnNumber("Used in DME", table)];
    // line. ahpMid = csvLine[this.getFieldColumnNumber("AHP Mid", table)];

    //TODO: paths are not implemented yet.
    // line.isSectOrScreeningOrFileLine = true;
    // line.inspectionRepPathId = csvLine[this.getFieldColumnNumber("Inspection Rep Path ID", table)];
    // line.inspectionRepPath = csvLine[this.getFieldColumnNumber("Inspection Rep Path", table)];
    // line.antenaRepPathId = csvLine[this.getFieldColumnNumber("Antena Rep Path ID", table)];
    // line.antenaRepPath = csvLine[this.getFieldColumnNumber("Antena Rep Path", table)];
    // line.vorInspectPathId = csvLine[this.getFieldColumnNumber("VOR Inspect Path ID", table)];
    // line.vorInspectPath = csvLine[this.getFieldColumnNumber("VOR Inspect Path", table)];

    return line;
  }

  static getFieldColumnNumber(fieldName: string, table: any): number {
    if (!ImportCSVTableFieldModel.getCheckedFromTable(fieldName, table))
      return null;

    return ImportCSVTableFieldModel.lettersToNumber(ImportCSVTableFieldModel.getLetterFromTable(fieldName, table))
  }

  static transformNavaidType(element: string) : string {
    if(element == "VOR/DME"){
      return "VOR_DME";
    }
    if (element == "DME(ILS)" || element == "DME (ILS)"){
      return "DME_ILS"
    }
    return element;
  }
}
